import { FC } from 'react'
import { observer } from 'mobx-react'
import { IAnswerBase } from '@/types'
import { getUserAvatar, useStores } from '@/utils'
import { OutSideOverlay } from '@/components/atoms/OutSideOverlay'
import { AddReplyForm } from '@/components/molecules/AddReplyForm'
import { Avatar } from '@/components/atoms/Avatar'
import { ReplyModalParentContent } from '@/components/molecules/ReplyModalParentContent'
import styles from './index.module.scss'

type Props = {
  parentReply?: IAnswerBase
  childReplies: IAnswerBase[]
  setReplies: (replies: IAnswerBase[]) => void
  isQuestioner: boolean
  isModalOpen: boolean
  setIsModalOpen: (isModalOpen: boolean) => void
}

export const ReplyModal: FC<Props> = observer(
  ({ parentReply, childReplies, setReplies, isQuestioner = false, isModalOpen = false, setIsModalOpen }) => {
    const { viewer } = useStores()

    const toggleModal = () => {
      if (!viewer.isInitialized) {
        return
      }

      setIsModalOpen(!isModalOpen)
    }

    return (
      <div className={styles.container} style={isModalOpen ? {} : { display: 'none' }}>
        <OutSideOverlay onClick={toggleModal} isOpen={isModalOpen} backGroundColor='gray' />
        <div className={styles.modal}>
          <div className={styles.card}>
            <ReplyModalParentContent reply={parentReply} toggleModal={toggleModal} isQuestioner={isQuestioner} />
            <div className={styles.main}>
              <div className={styles.avatar}>
                <Avatar src={getUserAvatar(viewer.viewer)} alt={viewer.viewer.name} />
              </div>
              <AddReplyForm
                slug={parentReply?.slug}
                replies={childReplies}
                setReplies={(newReplies: IAnswerBase[]) => setReplies(newReplies)}
                isModalOpen={isModalOpen}
                setIsModalOpen={(isOpen: boolean) => setIsModalOpen(isOpen)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
)
